import { RootState } from 'redux/root-reducer';

export const subscribedSubscriptionStateSelector = (state: RootState) =>
  state.accountSubscription;

export const subscribedSubscriptionSelector = (state: RootState) =>
  state.accountSubscription.subscription;
